import { api } from './client.js';
const unwrap = (r) => r.data?.data;

export const jiraApi = {
  // Issue extensions
  watchers: (id) => api.get(`/issues/${id}/watchers`).then(unwrap),
  watch: (id) => api.post(`/issues/${id}/watch`).then(unwrap),
  unwatch: (id) => api.delete(`/issues/${id}/watch`).then(unwrap),

  vote: (id) => api.post(`/issues/${id}/vote`).then(unwrap),
  unvote: (id) => api.delete(`/issues/${id}/vote`).then(unwrap),

  linkTypes: () => api.get('/issue-link-types').then(unwrap),
  links: (id) => api.get(`/issues/${id}/links`).then(unwrap),
  addLink: (id, payload) => api.post(`/issues/${id}/links`, payload).then(unwrap),
  removeLink: (linkId) => api.delete(`/issues/links/${linkId}`).then(unwrap),

  history: (id) => api.get(`/issues/${id}/history`).then(unwrap),

  // Project extensions
  components: (projectId) => api.get(`/projects/${projectId}/components`).then(unwrap),
  createComponent: (projectId, payload) => api.post(`/projects/${projectId}/components`, payload).then(unwrap),
  deleteComponent: (id) => api.delete(`/components/${id}`).then(unwrap),

  versions: (projectId) => api.get(`/projects/${projectId}/versions`).then(unwrap),
  createVersion: (projectId, payload) => api.post(`/projects/${projectId}/versions`, payload).then(unwrap),
  releaseVersion: (id) => api.post(`/versions/${id}/release`).then(unwrap),

  labels: (projectId) => api.get(`/projects/${projectId}/labels`).then(unwrap),
  createLabel: (projectId, payload) => api.post(`/projects/${projectId}/labels`, payload).then(unwrap),
  setIssueLabels: (issueId, labelIds) => api.put(`/issues/${issueId}/labels`, { labelIds }).then(unwrap),
  issueLabels: (issueId) => api.get(`/issues/${issueId}/labels`).then(unwrap),

  workflows: (projectId) => api.get(`/projects/${projectId}/workflows`).then(unwrap),
  saveWorkflow: (projectId, payload) => api.post(`/projects/${projectId}/workflows`, payload).then(unwrap),

  issueTypes: (projectId) => api.get(`/projects/${projectId}/issue-types`).then(unwrap),
};
